import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerDialogService } from '../../dialogs/customer/customer.service.dialog';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { CustomerService } from '../../services/customer.service';
import { StatusService } from '../../services/status.service';

@Component({
  selector: 'ap-pick-customer',
  templateUrl: './pick-customer.component.html',
  styleUrls: ['./pick-customer.component.scss']
})
export class PickCustomerComponent implements OnInit {

    @Input() customer: CustomerInterface | null = null;
    @Output() customerChange = new EventEmitter<CustomerInterface | null>();

    constructor(
        private customerService: CustomerService,
        private customerDialogService: CustomerDialogService) { }

    ngOnInit(): void {

    }

    public customers: CustomerInterface[] = [] as CustomerInterface[];
    isOpen = false;
    findCustomers(searchText: string) {
      this.customerService.search(searchText, 15).subscribe((r: any) => {
        this.customers = r;
      })
    }

    close() {
        this.isOpen = false;
        this.customers = [];
        this.customerChange.emit(this.customer);
    }

      pickCustomer(customer: CustomerInterface) {
        this.customer = customer;
        this.close();
      }

      chooseDifferentCustomer() {
        this.customer = null;
        this.isOpen = !this.isOpen
      }

      createCustomer(customerName = "") {

        this.customerDialogService.launchDialog(null, customerName, (r: any) => {
          this.customer = r;
          this.isOpen = !this.isOpen;
        });
      }

      editCustomer() {
        this.customerDialogService.launchDialog(this.customer, "", (r: any) => {
          if (r != "" && r != undefined) {
            this.customer = r;
          }
        });
      }

      hasCustomer() {
        if (this.customer == null) {
          return false;
        } else {
          return true;
        }
      }


}
